import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const CheckBox = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path d="M24 0H0v24h24V0Z" />
      <Path
        d="M16.02 3H7.98C5.24 3 3 5.24 3 7.98v8.04C3 18.76 5.24 21 7.98 21h8.04c2.74 0 4.98-2.24 4.98-4.98V7.98C21 5.24 18.76 3 16.02 3Zm3.18 13.02c0 1.75-1.43 3.18-3.18 3.18H7.98c-1.75 0-3.18-1.43-3.18-3.18V7.98c0-1.75 1.43-3.18 3.18-3.18h8.04c1.75 0 3.18 1.43 3.18 3.18v8.04Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default CheckBox
